import { render, staticRenderFns } from "./ServiceQuestion.vue?vue&type=template&id=4cb20eba&scoped=true"
import script from "./ServiceQuestion.vue?vue&type=script&lang=js"
export * from "./ServiceQuestion.vue?vue&type=script&lang=js"
import style0 from "./ServiceQuestion.vue?vue&type=style&index=0&id=4cb20eba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb20eba",
  null
  
)

export default component.exports